import type React from 'react'

import { useAuth } from '@/hooks'
import { clsJoin } from '@/utils'
import { AvatarRow } from '../../components/AvatarRow'
import {
  AvatarButton,
  DeleteAccountSection,
  EmailsSection,
  NotificationsSection,
  PersonalInfoSection,
  RegionSection,
} from './components'
import { useForm, useUserAvatar } from './hooks'
import css from './styles.module.css'

export const Account: React.FC = () => {
  const { onChange, state, onChangeEmail } = useForm()

  const { onUpload, onDelete } = useUserAvatar()
  const auth = useAuth()

  return (
    <div className={clsJoin(css.responsive, css.content)}>
      <PersonalInfoSection
        onChangeEmail={onChangeEmail}
        state={state}
        onChange={onChange}
      >
        <AvatarRow onUpload={onUpload} onDelete={onDelete}>
          <AvatarButton
            url={auth.avatar}
            name={auth.fullName}
            color={auth.color}
          />
        </AvatarRow>
      </PersonalInfoSection>
      <RegionSection state={state} onChange={onChange} />
      <NotificationsSection state={state} onChange={onChange} />
      <EmailsSection />
      <DeleteAccountSection />
    </div>
  )
}
